import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import { redirectToPage } from 'srcReact/helpers/history'
import Button from 'srcReact/components/common2/Button'
import IconButton from 'srcReact/components/common2/IconButton'
import Carousel from 'srcReact/components/common2/Carousel'
import WorkplaceGroupCard from './components/WorkplaceGroupCard'
import WorkplaceMemberGroupCard from './components/WorkplaceMemberGroupCard'
import { workplaceSettingsActions } from 'srcReact/WorkplaceSettingsPage'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import Divider from 'srcReact/components/common2/Divider'
import Spinner from 'srcReact/components/common2/Spinner'

const Groups = ({ selectedWorkplace }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    common: { isNative },
    workplaceSettings: { display, general_groups, member_led_groups }
  } = useSelector((state) => state)
  const [scope, setScope] = useState('all')
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })

  useEffect(() => {
    if (selectedWorkplace?.id > 0) {
      dispatch(workplaceSettingsActions.getWorkplaceGroups(selectedWorkplace?.id))
    }
  }, [selectedWorkplace])
  useEffect(() => {
    if (selectedWorkplace?.id > 0 && pagination?.isPagination) {
      dispatch(
        workplaceSettingsActions.getWorkplaceMemberLedGroups(selectedWorkplace?.id, scope, pagination?.nextOffset)
      )
    }
  }, [pagination])

  const getGroupRoleColor = (role) => {
    switch (role) {
      case 'organizer':
        return 'yellow'
      case 'co-organizer':
        return 'yellow'
      default:
        return 'blue'
    }
  }
  const handleSeeMore = () => {
    const nextOffset = pagination.nextOffset + appConstantSettings.WORKPLACE_PAGINATION_QUANTITY
    setScope('member_led_groups')
    setPagination({ nextOffset, isPagination: true })
  }

  return (
    <div className={styles.groupsWrapper}>
      <h3 className={styles.title}>{t('workplaceSettings.groups.generalGroups.title')}</h3>
      <p className={styles.description}>{t('workplaceSettings.groups.generalGroups.subtitle')}</p>

      {general_groups?.loaded && general_groups?.groups?.length > 0 && (
        <div className={styles.generalGroups}>
          <IconButton
            aria-label={t('global.add')}
            iconName='add'
            iconSize='large24'
            iconCSS={styles.addIcon}
            className={styles.addIconButton}
            onClick={() => redirectToPage(`/0/create-group/${selectedWorkplace?.id}`)}
          />
          <Carousel initialActive={0} className={styles.groups} showArrows={false} isArrowEdge={false}>
            {general_groups?.groups?.map((g, i) => {
              return (
                <WorkplaceGroupCard
                  g={{ ...g, role: 'organizer', workplace: { acronym: display?.accronym, color: display?.color } }}
                  i={i}
                  id={g.group_id}
                  handleClick={() => redirectToPage(`/0/home/group/${g.group_id}`, isNative, true)}
                  getGroupRoleColor={() => getGroupRoleColor('organizer')}
                />
              )
            })}
          </Carousel>
        </div>
      )}

      {general_groups?.loaded && general_groups?.groups?.length > 0 && <Divider className={styles.divider} />}

      {member_led_groups?.loaded && member_led_groups?.groups?.length > 0 && (
        <h3 className={styles.title}>{t('workplaceSettings.groups.ledGroups.title')}</h3>
      )}

      {member_led_groups?.loaded &&
        member_led_groups?.groups?.length > 0 &&
        member_led_groups?.groups?.map((g, i, arr) => (
          <React.Fragment key={i}>
            <WorkplaceMemberGroupCard
              group={g}
              groupId={g.group_id}
              handleClick={() => redirectToPage(`/0/home/group/${g.group_id}`, isNative, true)}
            />
            {i === arr.length - 1 ? null : <Divider />}
          </React.Fragment>
        ))}

      {!member_led_groups?.loading && member_led_groups?.stats?.remaining > 0 && (
        <Button type='button' text={t('global.seeMore')} customStyle={styles.seeMoreBtn} handleClick={handleSeeMore} />
      )}

      {(general_groups?.loading || member_led_groups?.loading) && <Spinner />}
    </div>
  )
}

export default Groups
